import { Box3, BoxGeometry, Mesh, MeshBasicMaterial, MeshPhongMaterial, SphereGeometry } from 'three';
import { Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export class SinkViewer extends ViewerModule {
    constructor(radius = 0.05) {
        super();
        Viewer.on('update', () => this.update());
        this.drips = [];
        this.radius = radius;
    }
    init() {
        // const front = new Mesh(new BoxGeometry(3, 1, 0.1).translate(0, 0, 1.5 - 0.05), new MeshPhongMaterial({color: 0xCCCCCC}));
        // const back = new Mesh(new BoxGeometry(3, 1, 0.1).translate(0, 0, -1.5 + 0.05), new MeshPhongMaterial({color: 0xCCCCCC}));
        // const Left = new Mesh(new BoxGeometry(0.1, 1, 3).translate(-1.5 + 0.05, 0, 0), new MeshPhongMaterial({color: 0xCCCCCC}));
        // const Right = new Mesh(new BoxGeometry(0.1, 1, 3).translate(1.5 - 0.05, 0, 0), new MeshPhongMaterial({color: 0xCCCCCC}));
        // const bottom = new Mesh(new BoxGeometry(3, 0.1, 3).translate(0, -0.5 + 0.05, 0), new MeshPhongMaterial({color: 0xCCCCCC}));
        //
        // this.addObject(front);
        // this.addObject(back);
        // this.addObject(left);
        // this.addObject(right);
        // this.addObject(bottom);
        //
        // const cylinder1 = new Mesh(new CylinderGeometry(0.2, 0.2, 5).translate(0, 2.5, -1.5), new MeshPhongMaterial({color: 0xCCCCCC}));
        // this.addObject(cylinder1);
        // const cylinder2 = new Mesh(new CylinderGeometry(0.2, 0.2, 1.5).rotateX(-Math.PI / 2).translate(0, 5, -0.75), new MeshPhongMaterial({color: 0xCCCCCC}));
        // this.addObject(cylinder2);
        // const cylinder3 = new Mesh(new CylinderGeometry(0.2, 0.2, 0.5).translate(0, 4.75, 0), new MeshPhongMaterial({color: 0xCCCCCC}));
        // this.addObject(cylinder3);
        // this.model = ResourcesManager.getModel('sink_4lvl').clone();
        // this.model.name = 'sink_4lvl';
        // // this.model.position.set(15, -19.4, 20);
        // // this.model.position.set(15, -8, 0);
        // this.model.rotateY(Math.PI);
        // // this.model.children[0].scale.set(0.5, 0.5, 0.5);
        // this.addObject(this.model);
        // const enableWater = () => {
        //     console.log('enableWater');
        //     this.actionController.off(ActionControllerEventName.click, this.model, enableWater);
        //     this.toggle(!this.currentMode);
        // };
        //
        // this.actionController.on(ActionControllerEventName.click, this.model, enableWater);
        this.drip = new Mesh(new SphereGeometry(this.radius, 18, 18), new MeshPhongMaterial({ color: 0x1111ee }));
    }
    toggle(mode) {
        this.currentMode = mode;
        if (!this.currentMode && this.drips) {
            this.drips.slice().forEach(drip => {
                this.drips.splice(this.drips.indexOf(drip), 1);
                this.uiObject.remove(drip);
            });
        }
        this.fire('toggled');
    }
    generatePlaceholder(dragndropGroup) {
        const box = new Mesh(new BoxGeometry(1.9, 0.001, 1.9), new MeshBasicMaterial({ visible: false }));
        box.position.y = 3.47;
        this.addObject(box);
        return dragndropGroup.addPlaceholder(box, new Box3().setFromObject(box), 'sink');
    }
    update() {
        if (Math.random() > 0.6 && this.currentMode) {
            const drip = this.drip.clone();
            drip.scale.multiplyScalar(1 + Math.random() / 5);
            drip.position.set(0, 0, -0.5);
            this.drips.push(drip);
            this.uiObject.add(drip);
        }
        if (this.drips)
            this.drips.slice().forEach(drip => {
                drip.translateY(-0.05);
                if (drip.position.y < -3) {
                    this.drips.splice(this.drips.indexOf(drip), 1);
                    this.uiObject.remove(drip);
                }
            });
    }
}
